import React from 'react'
import PropTypes from 'prop-types'
import {ArcElement, Chart as ChartJS} from "chart.js"
import {Pie} from "react-chartjs-2"


ChartJS.register(ArcElement)

const options = {
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
        tooltip: {
            displayColors: false,
            bodyAlign: "center",
            callbacks: {
                title: () => "",
                label: (data) => [
                    data.label + ":",
                    data.raw.toLocaleString("de-DE", {
                        minimumFractionDigits: 2,
                    }) + " EUR",
                ],
            },
        },
    },
}

const TpUiPieChart = ({data}) => <Pie options={options} data={data}/>

TpUiPieChart.propTypes = {
    data: PropTypes.exact({
        labels: PropTypes.arrayOf(PropTypes.string),
        datasets: PropTypes.arrayOf(
            PropTypes.exact({
                label: PropTypes.string,
                data: PropTypes.arrayOf(PropTypes.string),
                backgroundColor: PropTypes.string,
            }),
        ),
    }),
}

export default TpUiPieChart
